import React from 'react';

import * as S from './SpotlightArticle.styles';

const SPOTLIGHT_ARTICLE = {
  title: 'Music can improve focus for people with ADHD. Here’s what to listen for',
  url: 'https://news.northeastern.edu/2025/01/14/music-for-adhd-focus/',
  site: 'www.northeastern.edu',
  img: 'https://news.northeastern.edu/wp-content/uploads/2025/01/headphones1400.jpg?resize=1100,733',
};

export const SpotlightArticle = () => {
  return (
    <S.Container>
      <S.LeftContainer>
        <S.Content>
          <S.Text>{SPOTLIGHT_ARTICLE.title}</S.Text>
          <S.TextURL>{SPOTLIGHT_ARTICLE.site}</S.TextURL>
        </S.Content>

        <S.Button href={SPOTLIGHT_ARTICLE.url} rel="noopener noreferrer" target="_blank">
          <S.ButtonText>Read Article</S.ButtonText>
          <S.ArrowIcon alt="arrow right" src="https://cdn.brain.fm/icons/arrow-right.svg" />
        </S.Button>
      </S.LeftContainer>

      <S.RightContainer>
        <S.Img src={SPOTLIGHT_ARTICLE.img} />
      </S.RightContainer>
    </S.Container>
  );
};
